import { useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ChevronDown, Menu, X, ArrowRight } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { LOGO_URL } from "@/lib/api";
import { VERTICAL_REPARTI } from "@/lib/verticals";

const ROLES = [
  { label: "CEO · C-level", to: "/per-chi-e/ceo-c-level" },
  { label: "Manager · Middle mgmt", to: "/per-chi-e/manager" },
  { label: "Senior specialist", to: "/per-chi-e/senior-specialist" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [mobile, setMobile] = useState(false);
  const closeTimer = useRef(null);
  const navigate = useNavigate();

  const handleEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setOpen(true);
  };
  const handleLeave = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), 180);
  };

  return (
    <header className="sticky top-0 z-50 bg-lovac/85 backdrop-blur-md border-b border-lovac">
      <div className="container-lovac flex items-center justify-between h-16 px-6">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Lovac" className="h-7 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          <NavLink to="/metodo" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={NAV.metodo}>
            Il nostro metodo
          </NavLink>
          <NavLink to="/casi-studio" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={NAV.casiStudio}>
            Casi studio
          </NavLink>

          <div className="relative" onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
            <button
              className="nav-link flex items-center gap-1"
              data-testid={NAV.perChiE}
              onClick={() => navigate("/per-chi-e")}
            >
              Per chi è
              <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
              <div
                className="absolute top-full left-1/2 -translate-x-1/2 pt-3 w-[520px]"
                onMouseEnter={handleEnter}
                onMouseLeave={handleLeave}
              >
                <div className="bg-lovac border-lovac rounded-xl shadow-xl p-6 grid grid-cols-2 gap-6">
                  <div>
                    <p className="text-[11px] uppercase tracking-wider text-lovac-muted mb-3">Per ruolo</p>
                    <ul className="space-y-2">
                      {ROLES.map((r) => (
                        <li key={r.label}>
                          <Link to={r.to} className="text-sm text-lovac-dark hover:text-lovac-accent">
                            {r.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <p className="text-[11px] uppercase tracking-wider text-lovac-muted mb-3">Per reparto</p>
                    <ul className="space-y-2">
                      {VERTICAL_REPARTI.map((v) => (
                        <li key={v.key}>
                          <Link to={`/per-chi-e/${v.key}`} className="text-sm text-lovac-dark hover:text-lovac-accent flex items-center justify-between group">
                            {v.label}
                            <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>

          <NavLink to="/chi-siamo" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={NAV.chiSiamo}>
            Chi siamo
          </NavLink>
          <NavLink to="/hiring-scan" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={NAV.hiringScan}>
            Hiring Scan
          </NavLink>
        </nav>

        <div className="hidden lg:block">
          <Link to="/contatti" className="btn-primary" data-testid={NAV.ctaCall}>
            Prenota una call
          </Link>
        </div>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setMobile(!mobile)}
          data-testid={NAV.mobileToggle}
          aria-label="menu"
        >
          {mobile ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobile && (
        <div className="lg:hidden border-t border-lovac bg-lovac px-6 py-4 space-y-3">
          <Link to="/metodo" className="block py-2 text-sm" onClick={() => setMobile(false)}>Il nostro metodo</Link>
          <Link to="/casi-studio" className="block py-2 text-sm" onClick={() => setMobile(false)}>Casi studio</Link>
          <Link to="/per-chi-e" className="block py-2 text-sm" onClick={() => setMobile(false)}>Per chi è</Link>
          {VERTICAL_REPARTI.map((v) => (
            <Link key={v.key} to={`/per-chi-e/${v.key}`} className="block pl-4 py-1.5 text-sm text-lovac-muted" onClick={() => setMobile(false)}>
              {v.label}
            </Link>
          ))}
          <Link to="/per-chi-e/ceo-c-level" className="block pl-4 py-1.5 text-sm text-lovac-muted" onClick={() => setMobile(false)}>
            CEO · C-level
          </Link>
          <Link to="/per-chi-e/manager" className="block pl-4 py-1.5 text-sm text-lovac-muted" onClick={() => setMobile(false)}>
            Manager · Middle mgmt
          </Link>
          <Link to="/per-chi-e/senior-specialist" className="block pl-4 py-1.5 text-sm text-lovac-muted" onClick={() => setMobile(false)}>
            Senior Specialist
          </Link>
          <Link to="/chi-siamo" className="block py-2 text-sm" onClick={() => setMobile(false)}>Chi siamo</Link>
          <Link to="/hiring-scan" className="block py-2 text-sm" onClick={() => setMobile(false)}>Hiring Scan</Link>
          <Link to="/contatti" className="btn-primary w-full mt-2" onClick={() => setMobile(false)}>Prenota una call</Link>
        </div>
      )}
    </header>
  );
}
